import styled from 'styled-components';

export const ContainerNotFound = styled.div`
  width: 100%;
  height: 100%;

  display: flex;
  justify-content: center;
  align-items: center;
`;

export const ContentNotFound = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export default ContainerNotFound;
